<template>
  <div>
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <card class="card">
          <div class="d-flex justify-content-between">
            <h4 slot="header" class="card-title">
              Ramos
              <TotalRegisters :total="branchesTableData.total" totalText="ramos" />
            </h4>

            <div class="d-flex align-items-center">
              <button class="btn btn-info btn-sm" @click="$store.dispatch('branches/resetCreateError'), loadClasses(), loadItems(), (visibilityStates.create = true)">
                Adicionar Ramo
              </button>
            </div>
          </div>

          <Table :tableData="branchesTableData" :data="branches" :columns="['id', 'name', 'createdAt', 'updatedAt', 'actions']" :actions="['edit']" @pagechanged="onPageChange" @openDetailsModal="openDetailsModal" @openEditModal="openEditModal"> </Table>
          <ListLoader v-if="branchesTableData.loading" :height="40" :amount="8"></ListLoader>
          <Error v-if="!branchesTableData.loading && branchesTableData.error"></Error>
          <Empty v-if="!branchesTableData.loading && !branchesTableData.error && branches.length === 0"></Empty>
        </card>
      </div>
    </div>

    <Modal v-model="visibilityStates.create" :error="createError" action="Salvar" title="Adicionar novo Ramo" @closeModal="clear(), (visibilityStates.create = false)" @confirmAction="createBranch(newBranch)">
      <template v-slot:body>
        <div class="form-group">
          <label>Nome</label>
          <input type="text" class="form-control" v-model="newBranch.name" placeholder="Ex: Varejo" />
        </div>

        <div class="form-group">
          <label>Produtos e Serviços</label>
          <treeselect v-model="newBranch.items" placeholder="Selecione os produtos e serviços do ramo" :limit="6" :limitText="count => `e ${count} outras items`" :multiple="true" value-format="object" :options="items" :flat="true" :normalizer="normalizer" />
        </div>

        <div class="form-group">
          <label>Classes</label>
          <treeselect v-model="newBranch.classes" placeholder="Selecione as classes do ramo" :multiple="true" value-format="object" :options="classes" :flat="true" :normalizer="normalizer" />
        </div>
      </template>
    </Modal>

    <Modal v-model="visibilityStates.edit" action="Salvar" title="Editar Ramo" @closeModal="visibilityStates.edit = false" @confirmAction="updateBranch(branch)">
      <template v-slot:body>
        <div class="form-group">
          <label>Nome</label>
          <input type="text" hidden class="form-control" v-model="branch.id" />
          <input type="text" class="form-control" v-model="branch.name" />
        </div>

        <div class="form-group">
          <label>Produtos e Serviços</label>
          <treeselect v-model="branch.items" placeholder="Editar produtos e serviços do ramo" :multiple="true" value-format="object" :options="items" :flat="true" :limit="6" :limitText="count => `e ${count} outros itens`" :normalizer="normalizer" />
        </div>

        <div class="form-group">
          <label>Classes</label>
          <treeselect v-model="branch.classes" :multiple="true" value-format="object" :options="classes" :flat="true" :limit="6" :limitText="count => `e ${count} outras classes`" :normalizer="normalizer" />
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import Table from '@/components/Common/Table';
import Search from '@/components/Common/Search';
import TotalRegisters from '@/components/Common/TotalRegisters';
import Modal from '@/components/Modal/Modal';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  components: {
    Modal,
    TotalRegisters,
    Treeselect,
    Search,
    Table,
  },
  data() {
    return {
      newBranch: {
        name: '',
        classes: [],
        items: [],
      },
      successMessage: '',
      visibilityStates: {
        create: false,
        edit: false,
        delete: false,
      },
    };
  },
  computed: {
    branches() {
      return this.$store.getters['branches/getBranches'];
    },
    branchesTableData() {
      return this.$store.getters['branches/getBranchesTableData'];
    },
    branch() {
      return this.$store.getters['branches/getBranch'];
    },
    classes() {
      return this.$store.getters['classes/getAllClasses'];
    },
    items() {
      return this.$store.getters['items/getItems'];
    },
    createError() {
      return this.$store.getters['branches/getCreateError'];
    },
  },
  watch: {
    'visibilityStates.create': async function(state) {
      let vm = this;
      if (!state) {
        await this.$store.dispatch('branches/resetCreateError');
      }
    },
  },
  methods: {
    normalizer(node) {
      return {
        id: node.id,
        label: node.name,
      };
    },
    clear() {
      Object.assign(this.$data.newBranch, this.$options.data().newBranch);
    },
    loadClasses: async function() {
      await this.$store.dispatch('classes/getAllClasses');
    },
    loadItems: async function() {
      await this.$store.dispatch('items/getItemsNoLimit');
    },
    createBranch: async function(payload) {
      await this.$store.dispatch('branches/createBranch', payload);
      if (this.createError === '') {
        this.visibilityStates.create = false;
        this.clear();
      }
    },
    updateBranch: async function(params) {
      let payload = {
        id: params.id,
        params: {
          name: params.name,
          classes: params.classes.map(s => ({
            id: s.id,
          })),
          items: params.items.map(s => ({
            id: s.id,
          })),
        },
      };
      await this.$store.dispatch('branches/updateBranch', payload);
      this.visibilityStates.edit = false;
    },
    openDetailsModal: async function(id) {
      await this.$store.dispatch('branches/getBranchById', id);
      this.visibilityStates.readVisibility = true;
    },
    openEditModal: async function(id) {
      this.loadClasses();
      this.loadItems();
      await this.$store.dispatch('branches/getBranchById', id);
      this.visibilityStates.edit = true;
    },
    onPageChange(page) {
      this.$store.dispatch('branches/setPage', page);
    },
  },
  mounted() {
    this.$store.dispatch('branches/resetPagination');
  },
};
</script>
